import { render, staticRenderFns } from "./JournalView.vue?vue&type=template&id=f0583e5e"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports